<template>
  <div id="app">
    <Header />
    <div :class="{ wrap: wrap }">
      <BreadCrumb :isShow="breadcrumb" />
      <router-view />
    </div>
    <AnchorComp />
    <!-- <Footer /> -->
  </div>
</template>
<script>
import Header from "@components/header";
import Footer from "@components/footer/Footer";
import BreadCrumb from "@components/breadCrumb";
import AnchorComp from "@components/anchor/Anchor";
import Cookies from "js-cookie";
import * as addressApiV2 from "@fetch/addressV2";

import { getQueryString, unionFlag, delParam } from "@utils";
export default {
  name: "App",
  components: {
    Header,
    BreadCrumb,
    Footer,
    AnchorComp,
  },
  data() {
    return {
      breadcrumb: true,
      wrap: true,
    };
  },
  watch: {
    $route: function (route) {
      if (!route.meta.breadcrumb || unionFlag()) {
        this.breadcrumb = false;
      }
      if (route.name === "ActivityDetail" || route.name === "product/detail") {
        this.wrap = false;
      } else {
        this.wrap = true;
      }
    },
  },
  async mounted() {
    if (getQueryString("city")) {
      await this.setDefaultAddress(getQueryString("city"));
      window.df_sdk_common.location.replace(delParam("city"));
      return;
    }
    if (!Cookies.get("address")) {
      this.cacheAddress();
    }
    if(getQueryString('mc')) {
      window.sessionStorage.setItem('currentChannel', getQueryString('mc'));
    }
  },
  methods: {
    async setDefaultAddress(city) {
      let addressInfo = {};
      return addressApiV2.getDefaultAddress({ cityId: city })
        .then(({ body }) => {
          try {
            addressInfo = {
              provinceId: body.district && body.district.id,
              provinceName: body.district && body.district.name,
              cityName: body.city && body.city.name,
              cityId: body.city && body.city.id,
              regionId: body.region && body.region.id,
              regionName: body.region && body.region.name,
              streetId:
                body.streets && body.streets.length && body.streets[0].id,
              streetName:
                body.streets && body.streets.length && body.streets[0].name,
            };
            Cookies.set("address", addressInfo), { expires: 365 };
            Cookies.set("city", addressInfo.cityId), { expires: 365 };
            console.log("Cookies.set1", addressInfo);
            // window.location.reload();
          } catch (e) {
            console.log(e);
            this.cacheAddress();
          }
        });
    },
    cacheAddress() {
      Cookies.set(
        "address",
        {
          provinceId: 9,
          provinceName: this.TLang('上海市', 'my'),
          cityName: this.TLang('上海', 'my'),
          cityId: 145,
          regionId: 1222,
          regionName: this.TLang('黄浦区', 'my'),
          streetId: 16777,
          streetName: this.TLang('南京东路街道', 'my'),
        },
        { expires: 365 }
      );
      Cookies.set("city", 145), { expires: 365 };
      window.location.reload();
    },
  },
};
</script>
<style lang="less" scoped>
.wrap {
  min-height: 600px;
  // overflow-x: hidden;
}
</style>
